<template>
  <v-container
    class="auth-view fill-height"
    :class="!$store.state.isDarkMode ? 'bg-blue-darken-3' : 'dark-shadow'"
    fluid
  >
    <v-row
      justify="center"
      align="center"
      class="fill-height"
    >
      <v-col
        cols="12"
        align="center"
        class="mb-16"
      >
        <div
          class="mb-4 d-flex"
          style="max-width: 766px; align-items: center; justify-content: center;"
        >
          <v-img
            src="@/assets/icon-white.png"
            contain
            max-width="80"
            max-height="60"
            class="d-inline-block"
          ></v-img>
          <div class="d-inline-block text-white text-left">
            <div
              class="text-button font-weight-bold"
              style="margin-bottom: -10px;"
            >Webwalker</div>
            <div class="text-overline font-weight-bold">Automation</div>
          </div>
        </div>
        <v-card
          color="white"
          elevation="3"
          class="pa-3 mb-4 text-left"
          style="max-width: 766px; border-top: 4px solid #2196F3 !important; border-top-left-radius: 0; border-top-right-radius: 0; box-shadow: rgba(0, 0, 0, 0.1) 0px 10px 50px !important;"
        >
          <v-container>
            <v-row align="stretch">
              <v-col
                cols="12"
                lg="7"
                md="6"
                sm="12"
              >
                <v-card-title
                  class="text-h5"
                  style="word-break: break-word;"
                >
                  <slot name="title">{{ title }}</slot>
                </v-card-title>

                <slot></slot>
              </v-col>
              <v-col
                cols="1"
                lg="1"
                md="1"
                class="d-none d-md-flex justify-center"
              >
                <v-divider
                  vertical
                  class="auth-card-divider"
                ></v-divider>
              </v-col>
              <v-col
                cols="12"
                lg="4"
                md="5"
                sm="12"
              >
                <v-divider
                  class="d-md-none"
                  style="border-color: rgba(0, 0, 0, 0.75);"
                ></v-divider>

                <br />

                <slot name="side"></slot>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
        <div
          class="mb-16"
          style="position: relative;"
        >
          <base-error-alerts></base-error-alerts>
        </div>
        <slot name="footer"></slot>
      </v-col>
    </v-row>
    <slot name="other"></slot>
  </v-container>
</template>

<script>
export default {
  name: 'BaseAuthViewContainer',
  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style scoped>
.auth-view {
  min-height: 100vh !important;
  min-height: calc(100vh - 48px) !important;
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center bottom;
  box-shadow: inset 0 0 0 2000px rgba(21, 101, 192, 0.9);
}
.dark-shadow {
  box-shadow: inset 0 0 0 2000px #272727 !important;
}
.auth-card-divider {
  border-color: rgba(0, 0, 0, 0.75) !important;
  align-self: stretch;
  height: auto;
  min-height: 100%;
}
</style>
